module.exports = __webpack_public_path__ + "components/signup/static/app-mockup-2356fca062401d23a2d38a67f5966694.png";